import * as actions from './actions';

const defaultState = () => ({
  rules: [],
  isFetching: false,
  error: null
});

const notificationRulesReducer = (state = defaultState(), action) => {
  switch (action.type) {
    case actions.FETCH_NOTIFICATION_RULES_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actions.FETCH_NOTIFICATION_RULES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        rules: action.payload
      };
    case actions.FETCH_NOTIFICATION_RULES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case actions.POST_NOTIFICATION_RULE_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actions.POST_NOTIFICATION_RULE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        rules: [
          ...state.rules,
          action.payload
        ]
      };
    case actions.POST_NOTIFICATION_RULE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case actions.DELETE_NOTIFICATION_RULE_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actions.DELETE_NOTIFICATION_RULE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        rules: [
          ...state.rules.filter(rule => rule.id !== action.payload.id)
        ]
      };
    case actions.DELETE_NOTIFICATION_RULE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export { defaultState };
export default notificationRulesReducer;
